import { Container, Card, CardBody } from 'reactstrap';
import { Outlet, useNavigate } from "react-router-dom";

const Auth = () => {
  return (
    <Outlet />
  )
};

export default Auth;